import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmDialogProps {
  show: boolean;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger' | 'warning' | 'success';
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  icon?: React.ReactNode;
}

/**
 * Enterprise-grade confirmation dialog component
 * Standardized, compact design for all confirmation prompts
 */
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
  loading = false,
  icon
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onCancel} 
      centered 
      size="sm"
      backdrop="static"
      keyboard={!loading}
    >
      <Modal.Header closeButton={!loading} className="border-bottom-0 pb-2">
        <Modal.Title className="h6 mb-0">
          {icon && <span className="mr-2">{icon}</span>}
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2 pb-3">
        <div className="text-muted" style={{ fontSize: '0.9rem' }}>
          {message}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <Button 
          variant="light" 
          size="sm"
          onClick={onCancel} 
          disabled={loading}
          className="px-3"
        >
          {cancelText}
        </Button>
        <Button 
          variant={confirmVariant} 
          size="sm"
          onClick={onConfirm} 
          disabled={loading}
          className="px-3"
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              Processing...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
